export { ReviewsSwiper } from './ReviewsSwiper.js';